export default __webpack_public_path__ + "static/media/blog-six.2fbae53d.png";